import type { QueryHookOptions } from "@apollo/client";
import { gql, useLazyQuery } from "@apollo/client";

const RecentSearches_Shared_Query = gql`
  query RecentSearches_Shared_Query($source: ProductSearchSourceType) {
    currentUser {
      id
      recentSearches(source: $source) {
        id
        filterableId
        filterableName
        filterableType
        query
        updatedAt
      }
    }
  }
`;

// undefined is "All Categories"
type RecentCategoryType =
  | undefined
  | "Product"
  | "Ingredient"
  | "SupplementType"
  | "Condition"
  | "Brand";

interface RecentSearchesItem {
  id: string;
  filterableId: string;
  filterableName: string;
  filterableType: RecentCategoryType;
  query: string;
  updatedAt: string;
}

interface RecentSearchesData {
  currentUser: {
    id: string;
    recentSearches: RecentSearchesItem[];
  };
}

const useRecentSearchesLazyQuery = (options?: QueryHookOptions<RecentSearchesData>) => {
  return useLazyQuery<RecentSearchesData>(RecentSearches_Shared_Query, options);
};
export type { RecentSearchesData, RecentSearchesItem, RecentCategoryType };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { RecentSearches_Shared_Query, useRecentSearchesLazyQuery };
